{
  "headerConfig": {
    "logo": {
      "path": "../../Resources/Icons/Kodak",
      "description": "Kodak-logo",
      "NavigationLink": "https://www.kodak.com/en"
    },
    "CompanyURL": "https://www.kodak.com/en/company/home"
  },  
  "search_dropdowns":["report_categories", "DocumentCountry", "ProductLanguage"],

  "footerConfig": {
    "footer_Links": [
      { "link_name": "termsOfUse", "link": "https://kodak.com/go/siteterms" },
      { "link_name": "privacy", "link": "https://kodak.com/go/privacy" },
      {
        "link_name": "accessibility",
        "link": "https://kodak.com/go/accessibility"
      }
    ]
  }
}
